import type { IconData } from '@stacksjs/iconify-core'

export const slackAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.34 2a2 2 0 0 0 0 4h2V4a2 2 0 0 0-2-2m0 5.33H4a2 2 0 1 0 0 4h5.34a2 2 0 0 0 0-4\" opacity=\".25\"/><path fill=\"currentColor\" d=\"M22 9.33a2 2 0 1 0-4 0v2h2a2 2 0 0 0 2-2m-5.32 0V4a2 2 0 1 0-4 0v5.33a2 2 0 1 0 4 0\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M14.66 22a2 2 0 0 0 0-4h-2v2a2 2 0 0 0 2 2m0-5.33H20a2 2 0 0 0 0-4h-5.34a2 2 0 0 0 0 4\" opacity=\".7\"/><path fill=\"currentColor\" d=\"M2 14.67a2 2 0 1 0 4 0v-2H4a2 2 0 0 0-2 2m5.32 0V20a2 2 0 1 0 4 0v-5.33a2 2 0 1 0-4 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default slackAlt
